<template>
  <div id="page-user-edit">
    <vx-card v-if="operation_data">
      <div slot="no-body" class="tabs-container px-6 pt-6">
            <div class="tab-text">
              <template>
                <div id="user-edit-tab-info">
                  <!-- Content Row -->
                  <div class="vx-row">
                    <div class="vx-col md:w-1/2 w-full">
                      <vs-input class="w-full mt-4" label="Operation Category" v-model="operation_data.operationcategory.name_en" disabled />
                      <br/>
                      <vx-input-group class="mb-base">
                        <template slot="prepend">
                          <div class="prepend-text bg-primary">
                            <span>Internal ID   #</span>
                          </div>
                        </template>

                        <vs-input v-model="operation_data.id" disabled size="default" />
                      </vx-input-group>
                      <p class="w-full mt-4" style="font-size:85%">&nbsp;Operation Date <datepicker :inline="false" v-model="operation_data.date"></datepicker>
                      </p>
                    </div>
                    <div class="vx-col md:w-1/2 w-full">
                      <div class="w-full mt-4" v-if="operation_data.operationcategory.id != 3 && operation_data.operationcategory.id != 4">
                        <div v-if="operation_data.operationcategory.id === 1">Supplier</div>
                        <div v-else-if="operation_data.operationcategory.id === 2">Client</div>
                        <div class="vx-row">
                          <div class="vx-col w-full">
                              <v-select :options="data_option_people_name" v-model="personId" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              <br/><br/>
                  <template>
                    <div id="data-list-list-view" class="data-list-container">

                      <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

                      <vs-table ref="table" :data="products">

                        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                          <div class="flex flex-wrap-reverse items-center data-list-btn-container">

                            <!-- ACTION - DROPDOWN -->

                            <!-- ADD NEW -->
                            <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
                                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                                <span class="ml-2 text-base text-primary">Add Product</span>
                            </div> 
                            <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="copyProduct">
                                <feather-icon icon="CopyIcon" svgClasses="h-4 w-4" />
                                <span class="ml-2 text-base text-primary">Copy Product</span>
                            </div>
                          </div>
                        </div>

                        <template slot="thead">
                          <vs-th>#</vs-th>
                          <vs-th>Category Product</vs-th>
                          <vs-th>Name</vs-th>
                          <vs-th>Quantity</vs-th>
                          <vs-th v-if=" this.operation_data.operationcategory.id === 2">Unit Price (EUR/UoM)</vs-th>
                          <vs-th v-else-if=" this.operation_data.operationcategory.id === 1">Unit Cost (EUR/UoM)</vs-th>
                          <vs-th>UoM</vs-th>
                          <vs-th>Volume Unit (m3/UoM)</vs-th>
                          <vs-th>Volume Total (m3)</vs-th>
                          <vs-th v-if=" this.operation_data.operationcategory.id === 2">Total Revenue (EUR)</vs-th>
                          <vs-th v-else-if=" this.operation_data.operationcategory.id === 1">Total Cost (EUR)</vs-th>
                          <vs-th>Action</vs-th>
                        </template>

                          <template slot-scope="{data}">
                            <tbody>
                              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td>
                                  <p class="font-medium truncate">{{ indextr+1 }}</p>
                                </vs-td>

                                <vs-td>
                                  <p class="font-medium truncate">{{ tr.productcategory.name_en }}</p>
                                </vs-td>

                                <vs-td>
                                  <p>{{ tr.name }}</p>
                                </vs-td>

                                <vs-td>
                                  <p>{{ Math.abs(tr.operations_products.quantity).toFixed(4) }}</p>
                                </vs-td>
                                <vs-td>
                                  <p>{{ Math.abs(tr.operations_products.unit_price).toFixed(4) }}</p>
                                </vs-td>

                                <vs-td>
                                  {{ tr.uomsreference.name_en }}
                                </vs-td>

                                <vs-td>
                                  <p>{{ Math.abs(tr.volume).toFixed(4) }}</p>
                                </vs-td>
                                <vs-td>
                                  <p>{{ Math.abs(tr.volume * tr.operations_products.quantity).toFixed(4) }}</p>
                                </vs-td>
                                <vs-td>{{ Math.abs(tr.operations_products.unit_price*tr.operations_products.quantity).toFixed(4) }}</vs-td>
                                <vs-td class="whitespace-no-wrap">
                                  <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                                  <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteProduct(tr.id,tr.name)" />            
                                </vs-td>

                              </vs-tr>
                            </tbody>
                          </template>
                      </vs-table>
                    </div>
                  </template>
                  <!-- Save & Reset Button -->
                  <div class="vx-row">
                    <div class="vx-col w-full">
                      <div class="mt-8 flex flex-wrap items-center justify-end">
                        <vs-button v-if="operation_data.isactive"  type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord">Disable</vs-button>
                        <vs-button v-else  type="border" color="success" icon-pack="feather" icon="icon-trash" @click="confirmEnableRecord">Enable</vs-button>     
                        <vs-button class="ml-auto" color="success" @click="save_changes" :disabled="!validateForm">Save Changes</vs-button>
                      </div>
                      <br/>
                    </div>
                  </div>
                </div>
              </template>
            </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import vSelect from 'vue-select'
import axios from '@/axios.js'
import Datepicker from 'vuejs-datepicker'
import moduleOperationList from '@/store/operation/moduleOperationList.js'
import moment from 'moment'

export default {
  components: {
    DataViewSidebar,
    vSelect,
    Datepicker
  },
  data () {
    return {
      operation_data: null,
      product_data: null,
      data_option_people_name: [],
      //operation_data: JSON.parse(JSON.stringify(this.data)),
      selected: [],
      //itemsPerPage: 1000,
      isMounted: false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      buttonSubmitOpen: false,
      state:{},
      personId: null,
      producttodelete:null
    }
  },
  computed: {
    products () {
      return this.$store.state.operationList.operationproducts
    },
    validateForm () {
      return !this.errors.any() 
    },
    currentPage () {
      if (this.isMounted) {
        if (this.operation_data.id) return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      if (this.operation_data.id) return this.$refs.table ? this.$refs.table.queriedResults.length : this.users.length
    }
  },
  methods: {
    async getPeople()
    {
      axios.get('/people_name/data')
        .then((response) => {
          this.data_option_people_name = [...response.data]
          const ItemIndex = this.data_option_people_name.findIndex((p) => p.value === this.operation_data.people[0].id)
          this.personId = this.data_option_people_name.splice(ItemIndex, 1)
        })
    },
    confirmDeleteRecord () {
      let namealert = this.operation_data.operationcategory.name_en + ' #' + this.operation_data.id 
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Disable',
        text: `You are about to disable ${namealert}`,
        accept: this.deleteRecord,
        acceptText: 'Disable'
      })
    },
    confirmEnableRecord () {
      let namealert = this.operation_data.operationcategory.name_en + ' #' + this.operation_data.id 
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirm Enable',
        text: `You are about to re-enable ${namealert}`,
        accept: this.enableRecord,
        acceptText: 'Enable'
      })
    },
    enableRecord () {
      axios.post('/operation/enable', {id:this.operation_data.id})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
      this.$router.push({path:'/operation/'+this.operation_data.id})
      this.showEnableSuccess()
    },
    showEnableSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Operation Enable',
        text: 'The selected operation was successfully enabled'
      })
    },
    deleteRecord () {
      axios.post('/operation/disable', {id:this.operation_data.id})
        .then((response) => {
          resolve(response)
        })
        .catch(() => { })
      this.$router.push({path:'/operation/'+this.operation_data.id})
      this.showDeleteSuccess()
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Operation Deleted',
        text: 'The selected operation was successfully deleted'
      })
    },
    capitalize (str) {
      return str.slice(0, 1).toUpperCase() + str.slice(1, str.length)
    },
    copyProduct () {
      if (this.operation_data.id && this.personId[0].value)
      {
        var idoperationto = this.operation_data.id
        var idperson = this.personId[0].value      
        this.$router.push({path:'/operation/copyproduct/'+idperson+'/'+idoperationto})
      }
    },
    addNewData () {
      if (this.operation_data.id)
      {
        var idoperation = this.operation_data.id
        var idcategoryoperation = this.operation_data.operationcategory.id
        this.sidebarData = {idoperation,idcategoryoperation}
        this.toggleDataSidebar(true)
      }else
      {
        this.$vs.notify({
          color: 'alert',
          title: 'Alert!',
          text: 'Please select a Person before!'
        })
      }
    },
    save_changes () {
      /* eslint-disable */
      const obj = {
        id: this.operation_data.id,
        idperson: this.personId.value,
        date: moment(this.operation_data.date)
      }
      if (this.operation_data.id) {
        this.$store.dispatch('operationList/updateOperation', obj).catch(err => { console.error(err) })
        this.$router.push({name:'operation/operation-view'})

        this.$vs.notify({
          color: 'success',
          title: 'Operation Updated!',
          text: 'The operation was successfully updated'
        })
      }
    },
    showDeleteAddressSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Product Deleted',
        text: 'The Product was successfully deleted'
      })
    },
    deleteProductOne () {
      /*alert("idaddress"+this.addresstodelete)
      alert("idperson"+this.operation_data.id)*/
      const obj = {
            idproduct: this.producttodelete,
            idoperation: this.operation_data.id
      }
      if (!moduleOperationList.isRegistered) {
        this.$store.registerModule('operationList', moduleOperationList)
        moduleOperationList.isRegistered = true
      }
      this.$store.dispatch('operationList/removeItem',obj).catch(err => { console.error(err) })
      //refresh view after delete
      this.showDeleteAddressSuccess()
    },
    deleteProduct (id,name) {
        this.producttodelete = id;
        this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete the product ${name}`,
        accept: this.deleteProductOne,
        acceptText: 'Delete Product'
      })
    },
    editData (data) {
      data.idperson = this.operation_data.id
      data.idcategoryoperation = this.operation_data.operationcategory.id
      this.sidebarData = data
      this.toggleDataSidebar(true)
    }, 
    getActiveColors (status) {
      if (status === "true")   return 'primary'
      if (status === false) return 'danger'
      return 'warning'
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    redirection()
    {
        if (this.operation_data.operationcategory.id === 4)
        {
           // STAY
        }
        else
        { 
          this.$router.push({path:'/pages/error-404'})
        }
    },
    fetch_operation_data (userId) {
      if (userId)
      {
          this.$store.dispatch('operationList/fetchOperation', userId)
          .then(res => { 
            this.operation_data = res.data
            this.getPeople()
            this.redirection()
          })
          .catch(err => {
            if (err.response.status === 404) {
              this.user_not_found = true
              return
            }
            console.error(err) 
          })
      }
      else
      {
        this.operation_data = {}
      }
    },
    fetch_product_data (userId) {
      if (userId)
      {
        this.$store.dispatch('operationList/fetchOperationProducts', userId)
      }
      else
      {
        this.product_data = {}
      }
    }
  },
  
  created () {
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.fetch_operation_data(this.$route.params.userId)
    this.fetch_product_data(this.$route.params.userId)
    
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

